import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useDriverData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.DRIVER_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/carManage/lookup`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useDriverData;
